/**
 * Elarune Co. - cuenta atras de la banda promocional.
 *
 * Dos modos:
 *
 *   ciclo   Cuenta atras que se reinicia cada N horas. El tiempo restante
 *           se deriva del reloj (epoch % ciclo), no del momento en que se
 *           carga la pagina: dos personas que miren a la vez ven lo mismo,
 *           y recargar no reinicia el contador.
 *
 *   fecha   Cuenta atras real hasta una fecha ISO. Al expirar, la seccion
 *           se oculta en lugar de quedarse en ceros.
 *
 * Sin JS el bloque no se pinta, asi que nunca se ve un contador congelado.
 */

class ElaruneCountdown extends HTMLElement {
  connectedCallback() {
    this.mode = this.dataset.mode === 'date' ? 'date' : 'cycle';
    this.cycleSeconds = Math.max(60, parseInt(this.dataset.cycleHours, 10) * 3600 || 43200);
    this.deadline = this.dataset.target ? Date.parse(this.dataset.target) : NaN;

    this.units = {
      hours: this.querySelector('[data-ela-countdown-hours]'),
      minutes: this.querySelector('[data-ela-countdown-minutes]'),
      seconds: this.querySelector('[data-ela-countdown-seconds]'),
    };

    if (this.mode === 'date' && Number.isNaN(this.deadline)) {
      // Fecha mal escrita en el personalizador: mejor no mostrar nada
      // que mostrar un contador sin sentido.
      this.hideSection();
      return;
    }

    this.hidden = false;
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  remaining() {
    if (this.mode === 'date') {
      return Math.max(0, Math.floor((this.deadline - Date.now()) / 1000));
    }

    const elapsed = Math.floor(Date.now() / 1000) % this.cycleSeconds;
    return this.cycleSeconds - elapsed;
  }

  tick() {
    const left = this.remaining();

    if (this.mode === 'date' && left <= 0) {
      clearInterval(this.timer);
      this.hideSection();
      return;
    }

    this.write(this.units.hours, Math.floor(left / 3600));
    this.write(this.units.minutes, Math.floor((left % 3600) / 60));
    this.write(this.units.seconds, left % 60);
  }

  write(node, value) {
    if (!node) return;
    const text = String(value).padStart(2, '0');
    if (node.textContent !== text) node.textContent = text;
  }

  hideSection() {
    const section = this.closest('[data-ela-countdown-section]') || this;
    section.hidden = true;
  }
}

if (!customElements.get('elarune-countdown')) {
  customElements.define('elarune-countdown', ElaruneCountdown);
}
